module.exports = __webpack_public_path__ + "img/knu_gallery7.c672db06.jpg";